/**
 * Number formatter in style and currency
 * @param { number | undefined } value
 * @param { IOptions } options - Intl.NumberFormatOptions. Default: { style: 'currency', currency: 'USD' }
 * @returns Value formatted with Intl.NumberFormat
 */
function numberFormatter(
  value?: number,
  options: Intl.NumberFormatOptions = { style: 'currency', currency: 'USD' },
): string {
  if (!value && value !== 0) return '';
  const formatter = new Intl.NumberFormat('en-US', options);
  const format = formatter.format(value);
  return format;
}

export { numberFormatter };
